import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import Button from "components/shared/Button/Button";
import { deviceInterface } from "./Devices";

interface ReassignDeviceDialogProps {
  device: deviceInterface | null;
  ownerName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ReassignDeviceDialog({
  device,
  ownerName,
  onConfirm,
  onCancel
}: ReassignDeviceDialogProps) {
  return (
    <Dialog open={!!device} onClose={onCancel}>
      <DialogTitle>Reassign device</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This device is currently assigned to{" "}
          <strong>{ownerName || "another member"}</strong>. Confirming will move it to your
          list of devices to add — it won't be reassigned until you save.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="neutral" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}